import React, { Component } from 'react';
import styled from 'styled-components';
import { Grid, Header as H } from 'semantic-ui-react';

import camera from '../../assets/icons/camera.svg';
import cloud from '../../assets/icons/cloud.svg';
import eco from '../../assets/icons/eco.svg';
import gears from '../../assets/icons/gears.svg';

class Features extends Component {
  render() {
    return (
      <Container>
        <InnerContainer>
          <Header size="large" as="h1" textAlign="center">
            Our Unique Approach
          </Header>
          <Grid columns={4} padded stackable>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={4}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Image src={camera} />
              <Content className="content">
                <Title>{this.props.FeatureMonitor.title}</Title>
                <Text>{this.props.FeatureMonitor.text}</Text>
              </Content>
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={4}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Image src={cloud} />
              <Content className="content">
                <Title>{this.props.FeatureRemote.title}</Title>
                <Text>{this.props.FeatureRemote.text}</Text>
              </Content>
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={4}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Image src={eco} />
              <Content className="content">
                <Title>{this.props.FeatureSust.title}</Title>
                <Text>{this.props.FeatureSust.text}</Text>
              </Content>
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={4}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Image src={gears} />
              <Content className="content">
                <Title>{this.props.FeatureNonInv.title}</Title>
                <Text>{this.props.FeatureNonInv.text}</Text>
              </Content>
            </Grid.Column>
          </Grid>
        </InnerContainer>
      </Container>
    );
  }
}

export default Features;

const Container = styled.div`
  width: 100%;

  /* min-height: 100vh; */
  padding: 2rem 0;
  background: #262936;
  /* background: linear-gradient(to bottom, #262936, #243b55); */
  color: #d6e4ea;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 1100px) {
  }
  @media (max-width: 600px) {
  }
`;

const InnerContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

// const Header = styled(H)`
//   font-size: 50px !important;
//   line-height: 50px;
//   display: flex;
//   justify-content: center;
//   color: #4babc0 !important;
//   align-items: center;
//   padding: 1rem !important;
//   @media (max-width: 1000px) {
//     font-size: 40px;
//     line-height: 40px;
//   }
//   @media (max-width: 600px) {
//     /*padding: 20px 0;*/
//   }
// `;

const Header = styled(H)`
  color: #4babc0 !important;
  font-size: 50px !important;
  line-height: 50px !important;
  margin-bottom: 3rem !important;

  width: 500px;
  @media (max-width: 1150px) {
    width: 100% !important;
    padding: 0 50px !important;
  }
  @media (max-width: 950px) {
    text-align: center !important;
    margin-top: 20px !important;
    /* margin-bottom: 10px !important; */
    font-size: 30px !important;
    line-height: 30px !important;
    width: 100% !important;
  }
  @media (max-width: 400px) {
    width: 100% !important;
    font-size: 30px !important;
    margin-top: 25px !important;
  }
`;

const Image = styled.img`
  height: 70px;
  width: 70px;
  transition: all 500ms ease-in-out;
  z-index: 4;
  margin: 0 auto;
  @media (max-width: 800px) {
    height: 60px;
    width: 60px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  transition: all 200ms ease-in-out;
  z-index: 2;
  border-radius: 5px;

  @media (max-width: 1000px) {
    width: 75%;
    margin: 0 auto;
    max-width: 400px;
  }
`;

const Title = styled.div`
  width: 100%;
  padding: 0.5rem;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
  color: #4babc0;
  @media (max-width: 1270px) {
    font-size: 25px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 1150px) {
    font-size: 23px;
  }
  @media (max-width: 800px) {
    font-size: 20px;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
`;

const Text = styled.div`
  width: 100%;

  font-size: 1.3rem;
  display: flex;
  padding: 0.5rem 1rem;
  text-align: center;
  color: rgb(102, 109, 137);
  @media (max-width: 1270px) {
    font-size: 18px;
  }
  @media (max-width: 800px) {
    font-size: 18px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Features/index.js